import React, { useState } from 'react';
import useInView from '../../hooks/useInView';
import { useEmailSubscription } from '../../hooks/useEmailSubscription';
import './FinalCTA.css';

const FinalCTA = () => {
  const [email, setEmail] = useState('');
  const { subscribe, isLoading } = useEmailSubscription();
  const { ref, inView } = useInView({ threshold: 0.2 });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await subscribe(email);
    if (result.success) {
      setEmail('');
    }
  };

  return (
    <section ref={ref} className={`final-cta${inView ? ' final-cta--visible' : ''}`}>
      <div className="final-cta__container">
        <h2 className="final-cta__title">Join the rental revolution.</h2>
        <p className="final-cta__description">
          We're building the future of fair renting — and we need renters like you
          to help shape it. Get early access, influence the product, and be part of
          something that finally puts renters first.
        </p>
        <form onSubmit={handleSubmit} className="final-cta__form">
          <input
            type="email"
            placeholder="Enter your email"
            className="final-cta__input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
            required
          />
          <button
            type="submit"
            className="final-cta__button"
            disabled={isLoading}
          >
            {isLoading ? 'Joining...' : 'Join the Movement'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default FinalCTA;
